import { FC } from 'react';
import { StudentDiagnostic } from './StudentDiagnosticModal';
import { MaskedStudentData } from '../MaskedData/MaskedStudentData';
import { PiiTypes } from '../../analytics/dataMasking';

interface Props {
  student: StudentDiagnostic;
}

const StudentRow: FC<Props> = ({ student }) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-py-3 tw-border-b tw-border-solid tw-border-t-0 tw-border-x-0 tw-border-neutral-200">
      <span className="tw-text-base tw-font-atkinson tw-text-neutral-950">
        <MaskedStudentData student={student} type={PiiTypes.FullName}>
          {student.firstName} {student.lastName}
        </MaskedStudentData>
      </span>
      {student.questionsAnswered ? (
        <span className="tw-text-base tw-font-atkinson tw-text-neutral-950">
          <span className="tw-font-bold">{student.questionsAnswered}</span>
        </span>
      ) : null}
    </div>
  );
};

export default StudentRow;
